import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';
import { Bold } from './Bold.esm.js';

const sizeVariants = {
    sm: 'tw-text-xs tw-leading-normal tw-font-semibold',
    lg: 'tw-text-sm tw-font-semibold'
};
/**
 * Renders its children in CAPS and semibold.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Overline } from "@panwds/react-ui";
 * ```
 */
function Overline({ addClassName, as = 'span', size = 'sm', truncate = false, children, dataMetrics, dataTestId, ...passThrough }) {
    const className = classNames('tw-font-lato', sizeVariants[size], truncate && 'tw-flex', 'tw-uppercase tw-tracking-widest', addClassName);
    return (React.createElement(Bold, { "data-metrics": dataMetrics, "data-testid": dataTestId || 'overline', addClassName: className, appearance: "semibold", as: as, ...passThrough }, truncate ? React.createElement(TruncateText, null, children) : children));
}

export { Overline };
//# sourceMappingURL=Overline.esm.js.map
